import styled from 'styled-components';

export const OvulationBannerCategory = styled.div`
  margin: 0 -16px;
  padding-top: 22px;
  .doctorImg {
    position: relative;
    padding-top: 23%;
    @media (max-width: 720px) {
      padding-top: 34%;
    }

    width: 100%;
  }
  .lowOpacity {
    opacity: 0.5;
  }
  .categoryImage {
    position: relative;
    padding-top: 100%;
    width: 100%;
  }
  cursor: pointer;

  @media (max-width: 720px) {
    cursor: none;
  }
`;
export const CategoryContainer = styled.div`
  padding: 28px 13px;
  display: grid;
  gap: 18px;
  width: 72%;
  grid-template-columns: repeat(5, 1fr);
  @media (max-width: 720px) {
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
  }
`;

export const CategoryItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .categoryName {
    opacity: 0.64;
    font-size: 12px;
    font-weight: 500;
    color: #000;
    margin-top: 10px;
    text-align: center;
  }
  .lowOpacity {
    opacity: 0.5;
  }
  cursor: pointer;

  @media (max-width: 720px) {
    cursor: none;
  }
`;
